// Generated by scripts/update-seeq-icons.js from src/svg/seeq/annotate.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcAnnotate = {
  prefix: 'fak',
  iconName: 'annotate' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e903',
    'M51.2 911.4c-20.5 0-35.8-10.2-46.1-30.8s-5.1-41 10.3-56.3c66.6-61.4 102.4-117.8 97.2-168.9-71.7-61.4-112.6-133.1-112.6-210 0-189.4 225.3-337.9 512-337.9s512 148.5 512 337.9-225.3 337.9-512 338c-56.3 0-112.6-5.1-163.8-15.4-92.2 87-184.3 133.1-297 143.4 0 0 0 0 0 0zM204.8 619.5c10.2 51.2 5.1 97.3-20.5 148.5 35.8-20.5 76.8-51.2 112.7-87 10.2-10.2 30.7-20.5 46-15.4 51.2 15.4 107.5 20.5 163.9 20.5 225.3 0 414.7-107.5 414.7-240.7s-189.4-240.6-414.7-240.6-414.7 107.5-414.7 240.6c0 66.6 46.1 112.6 87 143.4 15.4 10.2 20.5 20.5 25.6 30.7zM378.9 450.6c0 33.9-27.5 61.4-61.5 61.4s-61.4-27.5-61.4-61.4c0-33.9 27.5-61.4 61.4-61.5s61.4 27.5 61.5 61.5zM573.4 450.6c0 33.9-27.5 61.4-61.4 61.4s-61.4-27.5-61.4-61.4c0-33.9 27.5-61.4 61.4-61.5s61.4 27.5 61.4 61.5zM768 450.6c0 33.9-27.5 61.4-61.4 61.4s-61.4-27.5-61.5-61.4c0-33.9 27.5-61.4 61.5-61.5s61.4 27.5 61.4 61.5z',
  ],
} satisfies IconDefinition;
